import React from 'react';

const wrapperStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '48px 24px',
  gap: 12,
};

const ballStyle: React.CSSProperties = {
  fontSize: 48,
};

const titleStyle: React.CSSProperties = {
  fontSize: 18,
  fontWeight: 600,
  color: '#FFFFFF',
  margin: 0,
};

const subStyle: React.CSSProperties = {
  fontSize: 14,
  color: 'rgba(255,255,255,0.6)',
  margin: 0,
};

export default function RecapEmptyState() {
  return (
    <div style={wrapperStyle}>
      <div style={ballStyle} aria-hidden>⚽</div>
      <p style={titleStyle}>Los jugadores todavía están calificando</p>
      <p style={subStyle}>Volvé en un rato 👀</p>
    </div>
  );
}
